import React, { memo } from "react";
import cx from "classnames";

// helpers

// dls
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

// constants
import { ITEM_LIST, TEST_ID_PLACEHOLDER } from "./constants";
import { ERROR_WIDGET_TEST_IDS } from "@swiggy-private/cart-test-ids";

// interfaces
import { ItemLimitExceededItem } from "@swiggy-private/cart-types";

// styles
import styles from "./styles/CartFooter.scss";
import { format } from "@core-ui/utils/String";

export interface ItemsListProps {
    items: ItemLimitExceededItem[];
}

const ItemsList: React.FC<ItemsListProps> = ({ items }) => {
    const isScrollable = items.length > ITEM_LIST.ITEMS_LIMIT;

    return (
        <div
            className={cx(styles.itemsList, {
                [styles.itemsListScrollable]: isScrollable,
            })}
            data-testid={ERROR_WIDGET_TEST_IDS.ITEMS_LIST}
        >
            <div className={styles.itemsListHeader} data-testid={ERROR_WIDGET_TEST_IDS.ITEMS_LIST_HEADER}>
                <Text variant="V2.overline.neutral.bold_spaced" color="text_Low_Emphasis">
                    {ITEM_LIST.ITEMS}
                </Text>
                <Text variant="V2.overline.neutral.bold_spaced" color="text_Low_Emphasis">
                    {ITEM_LIST.EXCEEDED}
                </Text>
            </div>

            <div
                className={cx(styles.itemsListScrollable, {
                    [styles.itemsListContentScrollable]: isScrollable,
                })}
            >
                {items.map((item, index) => (
                    <div
                        className={styles.itemsListItem}
                        key={index}
                        data-testid={format(TEST_ID_PLACEHOLDER, ERROR_WIDGET_TEST_IDS.ITEM, String(index))}
                    >
                        <div className={styles.itemsListItemContainer}>
                            <div className={styles.itemsListItemImageContainer}>
                                <Image cloudinaryId={item.imageId} fit="contain" />
                            </div>
                            <Text
                                variant="V2.body3.neutral.medium"
                                color="text_Med_Emphasis"
                                className={styles.itemsListItemContainerTitle}
                            >
                                {item.title}
                            </Text>
                        </div>
                        <Text variant="V2.body2.neutral.medium" color="text_Med_Emphasis">
                            {`${item.quantity} ${ITEM_LIST.UNITS}`}
                        </Text>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default memo(ItemsList);
